import { formatISO, getHours, getMinutes } from "date-fns/esm";

export function isObjectEmpty(obj: any) {
  return !obj || Object.entries(obj).length == 0;
}

export function flatDeep(arr: any[], d = 1): any[] {
  return d > 0
    ? arr.reduce(
        (acc, val) =>
          acc.concat(Array.isArray(val) ? flatDeep(val, d - 1) : val),
        []
      )
    : arr.slice();
}

export function haveCommonElements(arr1: any[], arr2: any[]): boolean {
  return arr1.some((item: any) => arr2.includes(item));
}

export function padNumber(num: number): string {
  return ("0" + num).slice(-2);
}

export function parseDate(date: Date): string {
  return formatISO(date, { representation: "date" }).split("-").join("");
}

export function dateToTime(date: string): string {
  const start = new Date(date);
  return `${padNumber(getHours(start))}:${padNumber(getMinutes(start))}`;
}

export function interpolate(
  base: string,
  variable: string,
  replacement: string
): string {
  const regex = new RegExp("\\" + variable, "gi");
  return base?.replace(regex, replacement) ?? "";
}

export function capitalize(text: string): string {
  return text && text.charAt(0).toUpperCase() + text.slice(1);
}
